/* eslint-disable */
export default {
  cancel: '취소',
  close: '닫기',
  ok: '확인',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
